export default __webpack_public_path__ + "static/media/37.59a6f229.jpg";